var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "list-unstyled"
  }, [_vm._l(_vm.item.items, function (link) {
    return _c('li', {
      key: link.id
    }, [_c('MdmLink', {
      staticClass: "item-link",
      attrs: {
        "url": link.url,
        "is-scramble-link": _vm.isScrambleLink,
        "is-prevent-default-link": false
      },
      domProps: {
        "textContent": _vm._s(link.label)
      },
      on: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, {
            data: link.tracking
          });
        }
      }
    })], 1);
  }), _vm._v(" "), _c('li', [_c('MdmLink', {
    staticClass: "more d-block font-weight-semibold",
    attrs: {
      "url": _vm.item.url,
      "is-scramble-link": _vm.isScrambleLink
    },
    domProps: {
      "textContent": _vm._s(_vm.item.footer)
    }
  })], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };